import { render, staticRenderFns } from "./CategoryProductPrice.vue?vue&type=template&id=3a19732c&"
import script from "./CategoryProductPrice.vue?vue&type=script&lang=ts&"
export * from "./CategoryProductPrice.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryProductPrice.vue?vue&type=style&index=0&id=3a19732c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports